import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Form, Icon } from 'semantic-ui-react'

import { getImageURL } from 'images'
import { ImageCrop } from 'ui'

import { actions, selectors } from '../redux'

import type { FC } from 'react'

import type { InstitutionSchema } from 'institutions'

export interface EditProps {
  institution: InstitutionSchema
}

const Edit: FC<EditProps> = ({ institution }) => {
  const dispatch = useDispatch()
  const [avatarURL, setAvatarURL] = useState(
    institution.avatar?.filename ? getImageURL(institution.avatar.filename, '200x200-fit') : '',
  )
  const [avatar, setAvatar] = useState<Blob | undefined>()
  const { loading } = useSelector(selectors.institution)

  const { formState, handleSubmit, register } = useForm({
    defaultValues: {
      address: institution.address,
      blurb: institution.blurb,
      email: institution.email,
      name: institution.name,
      nickname: institution.nickname,
      phone: institution.phone,
      web: institution.web,
    },
  })

  const onRemoveAvatar = () => {
    setAvatarURL('')
    setAvatar(undefined)
  }

  const onCutAvatar = (url: string, blob: Blob) => {
    setAvatarURL(url)
    setAvatar(blob)
  }

  const onSubmit = (values: {
    address?: string
    blurb?: string
    email?: string
    name: string
    nickname: string
    phone?: string
    web?: string
  }) => {
    dispatch(
      actions.institutionUpdate({
        ...values,
        id: institution.id,
        _avatar: !avatar && !avatarURL,
        avatar,
      }),
    )
  }
  return (
    <div className="bg-white p-2">
      <h3>Editar el equipo</h3>
      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-wrap gap-2 items-start">
          <div className="w-52">
            <ImageCrop
              contentClassName="drop-shadow border"
              cropHeight={200}
              cropWidth={200}
              onCut={onCutAvatar}
              onRemove={onRemoveAvatar}
              readOnly={loading}
              src={avatarURL}
            >
              <div>
                <Icon name="shield" size="big" />
                <br />
                Agrega el escudo de tu equipo
              </div>
            </ImageCrop>
          </div>
          <div className="min-w-72 max-w-96">
            <Form.Input error={formState.errors.name?.message} label="Nombre" readOnly={loading} required>
              <input
                {...register('name', {
                  maxLength: {
                    message: 'Máximo 100 caracteres',
                    value: 100,
                  },
                  required: 'El nombre es requerido',
                })}
                maxLength={100}
                type="text"
              />
            </Form.Input>
            <Form.Input
              className="!mb-0"
              error={formState.errors.nickname?.message}
              label="Nombre Corto"
              readOnly={loading}
              required
            >
              <input
                {...register('nickname', {
                  maxLength: {
                    message: 'Máximo 10 caracteres',
                    value: 10,
                  },
                  required: 'El nombre corto es requerido',
                })}
                maxLength={10}
                type="text"
              />
            </Form.Input>
            <div className="text-sm py-1">
              <Icon className="text-orange" name="warning sign" /> Te recomendamos <b>no editar</b> el nombre corto pues
              puede generar conflictos con los procesos automatizados del sistema.
            </div>
          </div>
        </div>
        <div>
          <Button
            content={loading ? 'Guardando...' : 'Guardar'}
            icon={loading ? 'spinner' : 'save'}
            primary
            readOnly={loading}
            type="submit"
          />
        </div>
      </Form>
    </div>
  )
}

export default Edit
